/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/aino'
export default icon
